"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
var _theme = _interopRequireDefault(require("../../theme"));
const useStyles = (0, _styles.makeStyles)({
  rootPageSection: {
    paddingTop: '60px',
    [_theme.default.breakpoints.down('lg')]: {
      paddingTop: '40px'
    },
    [_theme.default.breakpoints.down('sm')]: {
      paddingTop: '30px'
    },
    '& h1': {
      fontSize: _theme.default.typography.pxToRem(24),
      lineHeight: _theme.default.typography.pxToRem(36),
      fontFamily: _theme.default.typography.proxima.semiBold,
      color: _theme.default.palette.primary.main,
      marginBottom: '10px',
      [_theme.default.breakpoints.up('sm')]: {
        fontSize: _theme.default.typography.pxToRem(30),
        lineHeight: _theme.default.typography.pxToRem(45)
      },
      [_theme.default.breakpoints.up('xl')]: {
        fontSize: _theme.default.typography.pxToRem(36),
        lineHeight: _theme.default.typography.pxToRem(54)
      }
    },
    '& p': {
      fontFamily: _theme.default.typography.proxima.regular,
      fontSize: _theme.default.typography.pxToRem(16),
      lineHeight: _theme.default.typography.pxToRem(24),
      marginBottom: '20px',
      color: _theme.default.palette.grayScale.dark,
      [_theme.default.breakpoints.up('xl')]: {
        fontSize: _theme.default.typography.pxToRem(18),
        lineHeight: _theme.default.typography.pxToRem(27)
      },
      '& a': {
        display: 'inline',
        margin: 0
      }
    }
  }
});
var _default = exports.default = useStyles;